import {
  profileApiService,
} from '@/services/profile-api-service';
import {
  ProfileTransformer,
} from '@/transformers/profile/ProfileTransformer';
import {
  AxiosTransformedValue,
} from '@/transformers/types';
import {
  AxiosServicePromiseFactory,
} from '@/utils/axios-service-promise-factory';

export class ProfileAdaptor {
  public static get(): Promise<AxiosTransformedValue> {
    return AxiosServicePromiseFactory.getPromise(
      profileApiService,
      'get',
      void 0,
      ProfileTransformer,
    );
  }
}
